module.exports = __webpack_public_path__ + "static/one-percent_logo@2x-be83d29e0e82d26ee8bda148817863d4.png";